"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventDraggableEdge = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = require("react");
var react_dnd_1 = require("react-dnd");
var react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
var INDICATOR_STYLES = "absolute border-2 cursor-pointer pointer-events-auto border-opacity-0 border-lochivar-default inset-y-0 w-10 rounded-full z-20 cursor-pointer hover:bg-lochivar-default hover:bg-opacity-25 hover:border-opacity-100";
var EventDraggableEdge = function (_a) {
    var type = _a.type, uuid = _a.uuid, calendarId = _a.calendarId, className = _a.className, endDrag = _a.endDrag, beginDrag = _a.beginDrag;
    var _b = (0, react_dnd_1.useDrag)(function () { return ({
        type: type,
        item: function () {
            beginDrag(uuid, calendarId);
            return { uuid: uuid, calendarId: calendarId, type: type };
        },
        end: function () {
            endDrag(uuid, calendarId);
        },
    }); }, [uuid, calendarId, type]), _ = _b[0], drag = _b[1], preview = _b[2];
    (0, react_1.useEffect)(function () {
        preview((0, react_dnd_html5_backend_1.getEmptyImage)(), { captureDraggingState: true });
    }, [preview]);
    return (0, jsx_runtime_1.jsx)("div", { ref: drag, className: (0, clsx_1.default)(INDICATOR_STYLES, className) }, void 0);
};
exports.EventDraggableEdge = EventDraggableEdge;
